import type { FileAttachment } from '../Contracts'

/**
 * One-line preview for a message without text (chat list, toasts, replies) —
 * the messenger convention: a typed label for the first attachment.
 *
 * The generic fallback covers the chat list after a reload: the backend does
 * not serialize files of chat.lastMessage, but an empty content is only ever
 * valid WITH attachments (422 otherwise), so the label never lies.
 */
export const attachmentPreview = (files?: FileAttachment[]): string => {
    const first = files?.[0]
    if (!first) return '📎 Вкладення'

    switch (first.type) {
        case 'photo':
            return '📷 Фото'
        case 'video':
            return '🎬 Відео'
        default:
            return `📎 ${first.name}`
    }
}
